import Chip, { ChipProps } from '@mui/material/Chip';
import Tooltip, { TooltipProps } from '@mui/material/Tooltip';
import { SxProps } from '@mui/material/styles';
import { Theme } from '@mui/system';
import { FC, useMemo } from 'react';

import AssemblyDto from '../../dto/assemblies/out/assembly.dto';
import AssemblyStatusesEnum from '../../enums/assemblies/assembly-statuses.enum';

const { CANCELED, CONFIRMED, INCOMPLETE, PROCESSING } = AssemblyStatusesEnum;

interface Props {
  assembly: AssemblyDto;
  chipSx?: SxProps<Theme>;
}

const AssemblyStatusChip: FC<Props> = ({ chipSx = {}, assembly }) => {
  const { status } = assembly || { status: INCOMPLETE };

  const props = useMemo((): Pick<ChipProps, 'color'> => {
    switch (status) {
      case CANCELED: {
        return { color: 'default' };
      }
      case INCOMPLETE: {
        return { color: 'error' };
      }
      case PROCESSING: {
        return { color: 'warning' };
      }
      case CONFIRMED: {
        return { color: 'success' };
      }
    }
  }, [status]);

  const tooltipProps = useMemo((): Pick<TooltipProps, 'title'> => {
    switch (status) {
      case CANCELED: {
        return { title: 'Annulé' };
      }
      case INCOMPLETE: {
        return { title: 'Incomplet' };
      }
      case PROCESSING: {
        return { title: 'En traitement' };
      }
      case CONFIRMED: {
        return { title: 'Confirmé' };
      }
    }
  }, [status]);

  return (
    <Tooltip {...tooltipProps} arrow>
      <Chip
        {...props}
        sx={{
          height: '16px',
          width: '16px',
          ...chipSx,
        }}
      />
    </Tooltip>
  );
};

export default AssemblyStatusChip;
